import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ForwardCallForm from './ForwardCallForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    ...otherProps.initialValues,
    timeout: 15,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ForwardCallForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaForwardCall/ForwardCallForm.container.js